import {all, call, put, select, takeLatest} from 'redux-saga/effects';

import {
  getEmpireFooterContent,
  getNavigationContent,
} from 'services/api/aem/content-api';
import {ContentActions} from 'store/content';

import {empireFooterContentTimeStampSelector} from './content.selectors';

const SESSION_TIME = 3600000;

export function* getNavigationContentSaga() {
  try {
    const response = yield call(getNavigationContent);

    yield put(ContentActions.fetchNavigationSuccess(response.data));
  } catch (err) {
    yield put(
      ContentActions.fetchNavigationError({error: true, message: 'No results'})
    );
  }
}

export function* getEmpireFooterContentSaga() {
  try {
    const timestamp = yield select(empireFooterContentTimeStampSelector);
    if (!timestamp || timestamp < Date.now() - SESSION_TIME) {
      const response = yield call(getEmpireFooterContent);

      const parser = new DOMParser();
      const footer = parser.parseFromString(response.data, 'text/html');

      // Only return the body html from the response (removes any head/meta/script tags)
      const data = footer.body.innerHTML;

      yield put(ContentActions.fetchEmpireFooterContentSuccess(data));
    }
  } catch (err) {
    yield put(
      ContentActions.fetchEmpireFooterContentError({
        error: true,
        message: 'No results',
      })
    );
  }
}

export function* getHeaderFooterSuppressionSaga() {
  try {
    const suppressionParameter = yield call(() => {
      return new URLSearchParams(window.location.search).get('cetat');
    });

    if (suppressionParameter === 'playbytr') {
      const payload = true;
      yield put(ContentActions.suppressHeaderFooter(payload));
    }
  } catch (err) {}
}

export function* contentSagas() {
  yield all([
    takeLatest(ContentActions.fetchNavigation.type, getNavigationContentSaga),
    takeLatest(
      ContentActions.fetchEmpireFooterContent.type,
      getEmpireFooterContentSaga
    ),
    takeLatest(
      ContentActions.checkHeaderFooterSuppression.type,
      getHeaderFooterSuppressionSaga
    ),
  ]);
}
